import styled from 'styled-components';
import CheckmarkIcon from '@bufferapp/ui/Icon/Icons/Checkmark';

export const Checkmark = styled(CheckmarkIcon)`
  margin-right: 8px;
`;

export const Color = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 10px;
  display: flex;
  flex-shrink: 0;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  p {
    margin-left: 0px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
`;

export const TextWrapper = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
`;
